const bestSellingDataset = [
  {
    productName: 'Indomie',
    price: 5000,
    amountSold: 1000,
    src: "https://ecs7.tokopedia.net/img/cache/700/product-1/2019/4/24/1779754/1779754_f6a9267c-8cc0-44b9-8347-c794499a77bc_700_700.jpg"
  },
  {
    productName: 'Tolak Angin',
    price: 2500,
    amountSold: 950,
    src: "https://cdn.shopify.com/s/files/1/2976/8104/products/Tolak_Angin_PNG_600x600.png?v=1574132807"
  },
  {
    productName: 'Kopiko',
    price: 400,
    amountSold: 875,
    src: "https://ecs7.tokopedia.net/img/cache/700/product-1/2018/12/21/413247/413247_e7af7133-0205-4b2e-9ce1-bcab8c2cc070_648_648.jpg"
  },
  {
    productName: 'J.Co',
    price: 12000,
    amountSold: 750,
    src: "https://b.zmtcdn.com/data/pictures/chains/7/7400037/59b620414b7745b17d215e539154bd6e_featured_v2.jpg"
  },
  {
    productName: 'Kara',
    price: 400,
    amountSold: 700,
    src: "https://ecs7.tokopedia.net/img/cache/700/product-1/2019/8/7/6547701/6547701_29ea98c8-41ed-415c-be77-345c22dab6a4_300_300.jpg"
  },
];

export default bestSellingDataset;